import { postapicallnetworkservice } from '../apicallservice'
/**
 * SUBMIT RESAON
 */
export const fetchRVPProductDetails = async (payload, sendResult) => {
  let apiendpoint = `/shipment/getRVPproductdetails`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * Fetch shipment label data.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const fetchShipmentLabelData = async (payload, sendResult) => {
  let apiendpoint = `/expose/web/get/DataForDTOSlip`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload, { responseType: 'blob' });
  sendResult(resultData)
};


export const getStickerRestrictionFlag = async (payload, sendResult) => {
  let apiendpoint = `/external/get/sticker/restriction/flag`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * Check sticker restriction flags.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const fetchStickerRestrictionFlags = async (payload, sendResult) => {
  let apiendpoint = `/external/get/sticker/restriction/flag`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};
/**
 * Print bag sticker.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const printBagSticker = async (payload, sendResult) => {
  let apiendpoint = `https://localhost:4500/printer/printbagsticker`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};
/**
 * Add sticker log.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const addStickerLogService = async (payload, sendResult) => {
  let apiendpoint = `/external/RTO/sticker/add/log`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const showRTOLabelService = async (payload, sendResult) => {
  let apiendpoint = `/external/RTO/sticker/print/data`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const checkTransationLogsForPrintStrickerService = async (payload, sendResult) => {
  let apiendpoint = `/expose/check/transationLogsForPrintStricker`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const getTransationLogsForPrintStrickerService = async (payload, sendResult) => {
  let apiendpoint = `/expose/get/transationLogsForPrintStricker`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const storeRequestForPrintStrickerMobileWeb = async (payload, sendResult) => {
  let apiendpoint = `/expose/store/RequestForPrintStrickerMobileWeb`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const updateRequestForPrintStrickerMobileWeb = async (payload, sendResult) => {
  let apiendpoint = `/expose/update/RequestForPrintStrickerMobileWeb`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const shipmentGetRVPproductdetailsForMobileWeb = async (payload, sendResult) => {
  let apiendpoint = `/shipment/getRVPproductdetailsForMobileWeb`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

export const checkflyerbarcodeByshippingid = async (payload, sendResult) => {
  let apiendpoint = `/expose/verify/FlyerBarCodeAndShippingId`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};
export const checkTLQCStatus = async (payload, sendResult) => {
  let apiendpoint = `/DayEndClosure/checkTLQCStatus`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData.data)
};

/**
 *
 * @param {Object} payload
 *
 * get Allocated Details.
 */
export const uploadPrintLabelDamageImages = async (payload, sendResult) => {
  let apiendpoint = 'expose/uplaod/damageImageByShippingIdForWeb'
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
  sendResult(resultData)
}



/**
 * Fetch Shipment details.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const onePagerShipmentDetails = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/shipment-details`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};


/**
 * Update Shipment Status.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const updateShipmentStatusForOnePager = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/update-shipment`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};


/**
 * Update Shipment Status.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const varifyAndLinkShipmentAndFlyerBarcodeOnePager = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/varfiy-linking-shipment-flyerbarcode`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * Update Shipment Status.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const getRvpProductDetails = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/get-rvp-product-details`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * fetch Request list.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const onePageRequestList = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/get-print-request-list`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};


/**
 * fetch Request list.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const onePageVarifyAwbAndFlyer = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/verify-shipment-flyerbarcode`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * fetch Request list.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const getOnePagerEnabledFlag = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/get-one-pager-config`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};

/**
 * fetch Request list.
 * @param {Object} payload - The request parameters.
 * @returns {Promise} - Returns a promise with the server response.
 */
export const onePageReprintPendency = async (payload, sendResult) => {
  let apiendpoint = `/one-pager/get-one-pager-reprint-pendency`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};


//////////////////
// WEBPACK FOOTER
// ./services/modules/printlabelservices.js
// module id = 44
// module chunks = 1